import React from 'react';
import InputMask from 'react-input-mask';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { RadioGroup, RadioButton } from 'react-custom-radio';
import { cloneDeep } from 'lodash';
import {
  getAuthState,
  getEcapState,
  getOnboardingState,
} from '../../store/selectors';
import { saveEcap, getEcap, setEcap } from '../../store/actions';
import Checkmark from '../utility/Checkmark';
import ComponentHeader from './ComponentHeader';
import ErrorMessage from '../ErrorMessage';
import { chooseCareerPathCopy } from '../../copy/ecap/chooseCareerPathCopy.json';
import { handleFireGTM } from '../utility/routeUtil';

const continueButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant ? props.tenant.primary : 'white',
    borderColor: props.tenant ? props.tenant.primary : 'black',

    '&:hover': {
      backgroundColor: 'white',
      border: props.tenant
        ? `2px solid ${props.tenant.primary}`
        : '2px solid black',
      color: props.tenant ? props.tenant.primary : 'black',
      borderStyle: 'solid',
    },
  }),
};

export class Choosecareer_path extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      career_path: '',
      institution1: '',
      institution_costs1: '',
      application_deadline1: null,
      application_complete1: false,
      institution2: '',
      institution_costs2: '',
      application_deadline2: null,
      application_complete2: false,
      institution3: '',
      institution_costs3: '',
      application_deadline3: null,
      application_complete3: false,
      financial_aid: [],
      institutionsToDisplay: 1,
      additionalInfoOther: '',
      errors: {
        application_deadline1: false,
        application_deadline2: false,
        application_deadline3: false,
      },
    };
    this.institution1 = React.createRef();
    this.institution2 = React.createRef();
    this.institution3 = React.createRef();
  }

  displayNInstitutions = () => {
    const plan = this.props.location.pathname.includes('user-profile')
      ? this.props.ecapPlan
      : this.props.ecap.plan;

    let institutionsToDisplay = 1;
    for (let i = 2; i <= 3; i++) {
      if (
        plan[`institution${i}`] ||
        plan[`institution_costs${i}`] ||
        plan[`application_deadline${i}`] ||
        plan[`application_complete${i}`]
      ) {
        institutionsToDisplay = i;
      }
    }
    return institutionsToDisplay;
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.props.getEcap(this.props.auth.jwtToken);
    const plan = this.props.location.pathname.includes('user-profile')
      ? this.props.ecapPlan
      : this.props.ecap.plan;

    const institutionsToDisplay = this.displayNInstitutions();

    this.setState({
      institutionsToDisplay,
      career_path: plan.career_path ? plan.career_path : '',
      institution1: plan.institution1 ? plan.institution1 : '',
      institution_costs1: plan.institution_costs1
        ? plan.institution_costs1
        : '',
      application_deadline1: plan.application_deadline1
        ? moment(plan.application_deadline1).format('MM/DD/YYYY')
        : null,
      application_complete1: plan.application_complete1
        ? plan.application_complete1
        : false,
      institution2: plan.institution2 ? plan.institution2 : '',
      institution_costs2: plan.institution_costs2
        ? plan.institution_costs2
        : '',
      application_deadline2: plan.application_deadline2
        ? moment(plan.application_deadline2).format('MM/DD/YYYY')
        : null,
      application_complete2: plan.application_complete2
        ? plan.application_complete2
        : false,
      institution3: plan.institution3 ? plan.institution3 : '',
      institution_costs3: plan.institution_costs3
        ? plan.institution_costs3
        : '',
      application_deadline3: plan.application_deadline3
        ? moment(plan.application_deadline3).format('MM/DD/YYYY')
        : null,
      application_complete3: plan.application_complete3
        ? plan.application_complete3
        : false,
      financial_aid: plan.financial_aid ? plan.financial_aid : [],
      additionalInfoOther: plan.other_financial_aid_info
        ? plan.other_financial_aid_info
        : '',
    });
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.onRef(undefined);
  }

  async saveProgress() {
    const plan = cloneDeep(this.props.ecap.plan);
    const {
      career_path,
      institution1,
      institution_costs1,
      application_deadline1,
      application_complete1,
      institution2,
      institution_costs2,
      application_deadline2,
      application_complete2,
      institution3,
      institution_costs3,
      application_deadline3,
      application_complete3,
      financial_aid,
      additionalInfoOther,
    } = this.state;
    plan.career_path = career_path;
    plan.institution1 = institution1;
    plan.institution_costs1 = institution_costs1;
    plan.application_deadline1 = application_deadline1 || null;
    plan.application_complete1 = application_complete1;
    plan.institution2 = institution2;
    plan.institution_costs2 = institution_costs2;
    plan.application_deadline2 = application_deadline2 || null;
    plan.application_complete2 = application_complete2;
    plan.institution3 = institution3;
    plan.institution_costs3 = institution_costs3;
    plan.application_deadline3 = application_deadline3 || null;
    plan.application_complete3 = application_complete3;
    plan.financial_aid = financial_aid;
    plan.other_financial_aid_info = additionalInfoOther;
    await this.props.setEcap(plan);
  }

  getDynamicButton = () => {
    const temporaryValid = true;

    return temporaryValid ? this.props.classes.color : null;
  };

  handleRadioChange = (career_path) => {
    if (this._isMounted) {
      this.setState({ career_path });
    }
  };

  handleApplicationCheck = (i) => {
    const application_complete = cloneDeep(
      this.state[`application_complete${i}`]
    );
    if (this._isMounted) {
      this.setState((prevState) => ({
        ...prevState,
        [`application_complete${i}`]: !application_complete,
      }));
    }
  };

  onInputChange = async (event) => {
    event.persist();

    if (this._isMounted) {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  handleErrors = async (event, i) => {
    event.persist();
    if (!this._isMounted) return;
    this.setState((state) => {
      if (!this._isMounted) return;
      const errorsCopy = { ...state.errors };
      const instanceOfAppDeadline = `application_deadline${i}`;
      if (state[instanceOfAppDeadline] === '') {
        errorsCopy[instanceOfAppDeadline] = false;
        return { errors: errorsCopy };
      }
      const input = moment(state[instanceOfAppDeadline]);
      const fiveYearsInFuture = moment().add(5, 'years');
      const oneYearAgo = moment().subtract(1, 'years');
      if (
        state[instanceOfAppDeadline].includes('M') ||
        state[instanceOfAppDeadline].includes('D') ||
        state[instanceOfAppDeadline].includes('Y')
      ) {
        errorsCopy[instanceOfAppDeadline] = true;
        return { errors: errorsCopy };
      }
      if (!input.isValid()) {
        errorsCopy[instanceOfAppDeadline] = true;
        return {
          [instanceOfAppDeadline]: '',
          errors: errorsCopy,
        };
      }
      if (
        moment(input).isBefore(oneYearAgo, 'day') ||
        moment(input).isAfter(fiveYearsInFuture, 'day')
      ) {
        errorsCopy[instanceOfAppDeadline] = true;
        return {
          [instanceOfAppDeadline]: '',
          errors: errorsCopy,
        };
      }
      errorsCopy[instanceOfAppDeadline] = false;
      return { errors: errorsCopy };
    });
  };

  radioGroup = (options) => {
    const { primary } = this.props.tenant;
    const primaryColor = {
      background: `${primary}`,
    };
    const primaryBorder = {
      border: `1px solid ${primary}`,
    };
    const radioGroups = [];

    options.forEach((option) => {
      const selected = this.state.career_path === option;
      const getRadioRowClassName = () => {
        if (selected) {
          return 'radio-row selected';
        }
        if (
          !selected &&
          this.props.location.pathname.includes('user-profile')
        ) {
          return 'radio-row user-profile';
        }
        return 'radio-row';
      };

      radioGroups.push(
        <div key={option} className={getRadioRowClassName()}>
          <div className="radio-input">
            <span
              className={selected ? 'radio-fill' : 'radio-fill hidden'}
              style={primaryColor}
            />
            <RadioButton
              role="switch"
              value={option}
              className="radio-button"
              useHiddenInput
              style={primaryBorder}
              aria-checked={selected}
              aria-label={`Career Path Option: ${option}. ${
                selected ? 'selected' : 'unselected'
              }`}
              disabled={this.props.location.pathname.includes('user-profile')}
            />
            <label
              className="section-label"
              id={`career-${option.split(' ').join('-')}`}
            >
              {option}
            </label>
          </div>
          <div
            className={
              this.props.location.pathname.includes('user-profile') && selected
                ? 'section-border user-profile'
                : 'section-border'
            }
          />
        </div>
      );
    });

    return (
      <div className="radio-group-container">
        <RadioGroup
          name="career_path"
          selectedValue={this.state.career_path}
          onChange={this.handleRadioChange}
          className="radio-group"
          id="choose-path-type"
        >
          {radioGroups}
        </RadioGroup>
      </div>
    );
  };

  checkSelected = (option) => {
    const { financial_aid } = this.state;

    if (financial_aid && Object.values(financial_aid).indexOf(option) > -1) {
      return true;
    }

    return false;
  };

  handleFinanceCheck = (option) => {
    if (this._isMounted) {
      if (!this.checkSelected(option)) {
        this.setState((prevState) => {
          const newArray = prevState.financial_aid;

          newArray.push(option);

          return {
            ...prevState,
            financial_aid: newArray,
          };
        });
      } else {
        this.setState((prevState) => {
          const index = prevState.financial_aid.indexOf(option);
          const newArray = prevState.financial_aid;

          newArray.splice(index, 1);

          return {
            ...prevState,
            financial_aid: newArray,
          };
        });
      }
    }
  };

  checkGroup = (options) => {
    const { primary } = this.props.tenant;
    const primaryBorder = {
      border: `1px solid ${primary}`,
    };
    const checkGroups = [];

    options.forEach((option) => {
      const selected = this.checkSelected(option);

      const getCheckRowClassName = () => {
        if (selected) {
          return 'check-row selected';
        }
        if (
          !selected &&
          this.props.location.pathname.includes('user-profile')
        ) {
          return 'check-row user-profile';
        }
        return 'check-row';
      };

      checkGroups.push(
        <div key={option} className={getCheckRowClassName()}>
          <div className="checkbox-input multi">
            <div className={selected ? 'custom-check' : 'custom-check hidden'}>
              <Checkmark color={primary} />
            </div>
            <RadioButton
              onClick={() => this.handleFinanceCheck(option)}
              value={option}
              className="custom-checkbox"
              useHiddenInput
              style={primaryBorder}
              aria-labelledby={`finance-${option}`}
              disabled={this.props.location.pathname.includes('user-profile')}
            />
            <label id={`finance-${option}`} className="section-label">
              {option}
            </label>
          </div>
          <div
            className={
              this.props.location.pathname.includes('user-profile') && selected
                ? 'section-border user-profile'
                : 'section-border'
            }
          />
        </div>
      );
    });

    return (
      <div className="check-group-container">
        <RadioGroup
          selectedValue="select"
          name="career_path"
          className="radio-group"
          id="choose-financing"
        >
          {checkGroups}
        </RadioGroup>
      </div>
    );
  };

  displayInstitutionInfo = (i) => {
    const { errors } = this.state;
    const institution = this.state[`institution${i}`];
    const institution_costs = this.state[`institution_costs${i}`];
    const application_deadline = this.state[`application_deadline${i}`];
    const application_complete = this.state[`application_complete${i}`];

    const primaryBorder = {
      border: `1px solid ${this.props.tenant.primary}`,
    };

    const primaryColor = {
      color: `${this.props.tenant.primary}`,
    };

    return (
      <Translation key={`translation-${i}`}>
        {(t) => (
          <div key={`institution-${i}`} className="path-type-section">
            <div className="path-type-section">
              <label
                className="label-choose-path"
                htmlFor="insitution"
                style={primaryColor}
              >
                {t('Institution')}
              </label>
              {this.props.location.pathname.includes('user-profile') ? (
                <div
                  className="institution-choose-path"
                  aria-label={`Name of institution ${i}.`}
                >
                  {institution.length > 0
                    ? institution
                    : 'No institution entered'}
                </div>
              ) : (
                <input
                  type="text"
                  onChange={this.onInputChange}
                  value={institution}
                  placeholder={t('Name of Institution (optional)')}
                  className="form-choose-path"
                  aria-label={`Name of institution ${i}.`}
                  id={`institution${i}`}
                  ref={(input) => {
                    this[`institution${i}`] = input;
                  }}
                  disabled={this.props.location.pathname.includes(
                    'user-profile'
                  )}
                />
              )}
              {this.props.location.pathname.includes('user-profile') ? (
                <div
                  className="institution-choose-path"
                  aria-label={`institution costs ${i}`}
                >
                  {institution_costs.length > 0
                    ? institution_costs
                    : 'No institution cost entered'}
                </div>
              ) : (
                <input
                  type="text"
                  onChange={this.onInputChange}
                  value={institution_costs}
                  placeholder={t('Institution Costs Per Year (optional)')}
                  className="form-choose-path"
                  aria-label={`institution costs ${i}`}
                  id={`institution_costs${i}`}
                  disabled={this.props.location.pathname.includes(
                    'user-profile'
                  )}
                />
              )}
            </div>
            <div className="path-type-section">
              <div className="form-label-error-input">
                <div className="label-and-error">
                  {this.props.location.pathname.includes('user-profile') ? (
                    <label
                      className="label-choose-path"
                      htmlFor="deadline"
                      style={primaryColor}
                    >
                      {t('Institution Application Deadline')}
                      <div className="deadline-choose-path">
                        {application_deadline !== null
                          ? application_deadline
                          : 'No application deadline entered'}
                      </div>
                    </label>
                  ) : (
                    <label
                      className="label-choose-path"
                      htmlFor="deadline"
                      style={primaryColor}
                    >
                      {t('Institution Application Deadline')}
                    </label>
                  )}
                  <span
                    id="deadline-error"
                    aria-live="assertive"
                    role="alert"
                    aria-atomic="true"
                    aria-relevant="text"
                    style={{
                      display: errors[`application_deadline${i}`] ? '' : 'none',
                    }}
                  >
                    <ErrorMessage
                      error={t('Please enter your application deadline')}
                    />
                  </span>
                </div>
                {!this.props.location.pathname.includes('user-profile') && (
                  <InputMask
                    placeholder={chooseCareerPathCopy.inputC1}
                    id={`application_deadline${i}`}
                    className={
                      errors.activity
                        ? 'form-choose-path error'
                        : 'form-choose-path'
                    }
                    mask="99/99/9999"
                    maskPlaceholder={chooseCareerPathCopy.inputC1}
                    onChange={this.onInputChange}
                    value={application_deadline || ''}
                    aria-label={`application deadline ${i}`}
                    onBlur={(event) => {
                      this.handleErrors(event, i);
                    }}
                    disabled={this.props.location.pathname.includes(
                      'user-profile'
                    )}
                  />
                )}

                <div
                  className={
                    this.props.location.pathname.includes('user-profile')
                      ? 'application-check-container user-profile'
                      : 'application-check-container'
                  }
                >
                  <RadioGroup
                    name={`application_complete${i}`}
                    selectedValue="select"
                    onChange={() => {
                      this.handleApplicationCheck(i);
                    }}
                    className="checkbox-group"
                    id={`application_complete${i}`}
                  >
                    <div className="checkbox-input">
                      <div
                        className={
                          application_complete
                            ? 'custom-check low'
                            : 'custom-check low hidden'
                        }
                      >
                        <Checkmark color={this.props.tenant.primary} />
                      </div>
                      <RadioButton
                        role="switch"
                        value
                        aria-checked={this.state[`application_complete${i}`]}
                        className="custom-checkbox"
                        useHiddenInput
                        style={primaryBorder}
                        aria-label={`Application complete for institution ${i}.`}
                        disabled={this.props.location.pathname.includes(
                          'user-profile'
                        )}
                      />
                      <label
                        className="section-label"
                        id="application_complete"
                      >
                        {t('Application Complete')}
                      </label>
                    </div>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  };

  submitPlan = async () => {
    const plan = cloneDeep(this.props.ecap.plan);
    const {
      career_path,
      institution1,
      institution_costs1,
      application_deadline1,
      application_complete1,
      institution2,
      institution_costs2,
      application_deadline2,
      application_complete2,
      institution3,
      institution_costs3,
      application_deadline3,
      application_complete3,
      financial_aid,
      additionalInfoOther,
    } = this.state;

    plan.career_path = career_path;
    plan.institution1 = institution1;
    plan.institution_costs1 = institution_costs1;
    plan.application_deadline1 = application_deadline1 || null;
    plan.application_complete1 = application_complete1;
    plan.institution2 = institution2;
    plan.institution_costs2 = institution_costs2;
    plan.application_deadline2 = application_deadline2 || null;
    plan.application_complete2 = application_complete2;
    plan.institution3 = institution3;
    plan.institution_costs3 = institution_costs3;
    plan.application_deadline3 = application_deadline3 || null;
    plan.application_complete3 = application_complete3;
    plan.financial_aid = financial_aid;
    plan.other_financial_aid_info = additionalInfoOther;

    await this.props.saveEcap(this.props.auth.jwtToken, plan);
  };

  get displayOtherInput() {
    return this.state.financial_aid.includes('Other');
  }

  handleRoutingGTM = () => {
    handleFireGTM(
      this.props.tenant.name,
      'click "continue" from career path',
      this.props.location.pathname
    );
  };

  render() {
    const { primary } = this.props.tenant;
    let institutionsToDisplay = this.state.institutionsToDisplay;
    const institutionSection = [];
    for (let i = 1; i < institutionsToDisplay + 1; i++) {
      institutionSection.push(this.displayInstitutionInfo(i));
    }

    const primaryColor = {
      color: `${primary}`,
    };

    return (
      <Translation>
        {(t) => (
          <div id="choose-career-path">
            <ComponentHeader
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('Career Path')
                  : t('Choose Your Career Path')
              }
              tenant={this.props.tenant}
              marginTop="0px"
              appendText="chooseCareerPath"
            />
            <div className="path-type-section">
              <label
                className="label-choose-path"
                htmlFor="choose-path-type"
                style={primaryColor}
              >
                {!this.props.location.pathname.includes('user-profile') &&
                  t('Choose One')}
              </label>
              {this.radioGroup([
                t('4 year degree at university'),
                t('2 year degree at university'),
                t('Community College and transfer to university'),
                t('Vocational/Technical School'),
                t('Military Service'),
                t('Work'),
                t('Undecided'),
              ])}
            </div>
            {institutionSection}
            {!this.props.location.pathname.includes('user-profile') && (
              <div
                className="new-institution-button-container"
                style={{
                  display: institutionsToDisplay >= 3 ? 'none' : 'block',
                }}
              >
                <button
                  className="new-institution-button"
                  style={primaryColor}
                  onClick={() => {
                    this.setState(
                      {
                        institutionsToDisplay: (institutionsToDisplay += 1),
                      },
                      () => {
                        this[
                          `institution${this.state.institutionsToDisplay}`
                        ].focus();
                      }
                    );
                  }}
                  type="button"
                  disabled={institutionsToDisplay >= 3}
                >
                  {t('Add another institution')}
                </button>
              </div>
            )}

            <div className="path-type-section">
              <label
                className="label-choose-path"
                htmlFor="choose-path-type"
                style={primaryColor}
              >
                {t('Financial Aid')}
              </label>
              {this.checkGroup([
                t('Loans'),
                t('FAFSA'),
                t('Scholarships'),
                t('Grants'),
                t('Other'),
              ])}
            </div>
            {this.displayOtherInput ? (
              <div className="path-type-section">
                <label
                  className="label-choose-path"
                  htmlFor="insitution"
                  style={primaryColor}
                >
                  {t('Additional Details (Optional)')}
                </label>
                <input
                  type="text"
                  onChange={this.onInputChange}
                  value={this.state.additionalInfoOther}
                  placeholder={t('Enter additional details')}
                  className="form-choose-path"
                  aria-label={t('Other Additional Information')}
                  id="additionalInfoOther"
                />
              </div>
            ) : null}
            {!this.props.location.pathname.includes('user-profile') && (
              <div className="submit-button-container">
                <button
                  aria-label={t('Save your progress and continue')}
                  type="submit"
                  className={['button--primary', this.getDynamicButton()].join(
                    ' '
                  )}
                  id="submit-button"
                  onClick={async () => {
                    this.handleRoutingGTM();
                    await this.submitPlan();
                    return this.props.scrollNext();
                  }}
                >
                  {t('Continue')}
                </button>
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const ecap = getEcapState(state);
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  return { ecap, auth, onboarding };
};

const Choosecareer_pathWithRouter = withRouter(
  connect(mapStateToProps, {
    getEcap,
    saveEcap,
    setEcap,
  })(withStyles(continueButtonStyles)(Choosecareer_path))
);

export default Choosecareer_pathWithRouter;
